<app-website-header></app-website-header>
<div class="not-found">
    <h1>404 - Page Not Found</h1>
    <p>{{ message }}</p>
    <a routerLink="/">Go Back to Home</a>
  </div>
  <app-website-footer></app-website-footer>